/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import { Icons } from 'components/icons'
import './styles.scss'

// TODO Set the correct article ID here
const ARTICLE_ID = '00000000'

export function AppComponent() {
  return (
    <div className='index'>
      <ThemeSwitch />
      <div className='comparison'>
        <h3>Les forces militaires de l’Ukraine et de la Russie</h3>

        <div className='title'>
          <img className='ui flag image' src={require('../../images/ua.svg')} />{' '}
          Ukraine
        </div>
        <div className='title'>
          <img className='ui flag image' src={require('../../images/ru.svg')} />{' '}
          Russie
        </div>

        <div className='subtitle'>Budget</div>
        <div className='column left'>
          <div className='bar budget ukraine'>&nbsp;</div>
          <div className='label'>2,49 milliards de dollars</div>
        </div>
        <div className='column right'>
          <div className='bar budget russia'>
            <div className='label'>41,01 milliards de dollars</div>
          </div>
        </div>
        <div className='unit'>
          en milliards de dollars américains constants de 2015
        </div>

        <div className='subtitle'>Soldats</div>
        <div className='column left'>
          <div className='number'>196'600</div>
          <Icons count={10} image={require('../../images/soldat-ua.svg')} />
        </div>
        <div className='column right'>
          <div className='number'>900'000</div>
          <Icons count={45} image={require('../../images/soldat-ru.svg')} />
        </div>
        <div className='unit'>
          <img src={require('../../images/soldat.svg')} className='ui image' />=
          20'000
        </div>

        <div className='subtitle'>Véhicules de combat</div>
        <div className='column left'>
          <div className='number'>2870</div>
          <Icons
            count={3}
            image={require('../../images/kampffahrzeug-ua.svg')}
          />
        </div>
        <div className='column right'>
          <div className='number'>19'783</div>
          <Icons
            count={20}
            image={require('../../images/kampffahrzeug-ru.svg')}
          />
        </div>
        <div className='unit'>
          <img
            src={require('../../images/kampffahrzeug.svg')}
            className='ui image'
          />
          = 1000
        </div>

        <div className='subtitle'>Tanks</div>
        <div className='column left'>
          <div className='number'>2119</div>
          <Icons count={2} image={require('../../images/panzer-ua.svg')} />
        </div>
        <div className='column right'>
          <div className='number'>13'367</div>
          <Icons count={13} image={require('../../images/panzer-ru.svg')} />
        </div>
        <div className='unit'>
          <img src={require('../../images/panzer.svg')} className='ui image' />=
          1000
        </div>

        <div className='subtitle'>Artillerie</div>
        <div className='column left'>
          <div className='number'>1962</div>
          <Icons count={2} image={require('../../images/artillerie-ua.svg')} />
        </div>
        <div className='column right'>
          <div className='number'>5934</div>
          <Icons count={6} image={require('../../images/artillerie-ru.svg')} />
        </div>
        <div className='unit'>
          <img
            src={require('../../images/artillerie.svg')}
            className='ui image'
          />
          = 1000
        </div>

        <div className='subtitle'>Avions de combat</div>
        <div className='column left'>
          <div className='number'>146</div>
          <Icons
            count={2}
            image={require('../../images/kampfflugzeug-ua.svg')}
          />
        </div>
        <div className='column right'>
          <div className='number'>1328</div>
          <Icons
            count={13}
            image={require('../../images/kampfflugzeug-ru.svg')}
          />
        </div>
        <div className='unit'>
          <img
            src={require('../../images/kampfflugzeug.svg')}
            className='ui image'
          />
          = 100
        </div>

        <div className='subtitle'>Hélicoptères de combat</div>
        <div className='column left'>
          <div className='number'>42</div>
          <Icons
            count={2}
            image={require('../../images/kampfhelikopter-ua.svg')}
          />
        </div>
        <div className='column right'>
          <div className='number'>478</div>
          <Icons
            count={24}
            image={require('../../images/kampfhelikopter-ru.svg')}
          />
        </div>
        <div className='unit'>
          <img
            src={require('../../images/kampfhelikopter.svg')}
            className='ui image'
          />
          = 20
        </div>

        <div className='subtitle'>Navires de guerre</div>
        <div className='column left'>
          <div className='number'>2</div>
          <Icons
            count={1}
            image={require('../../images/kriegsschiff-ua.svg')}
          />
        </div>
        <div className='column right'>
          <div className='number'>74</div>
          <Icons
            count={37}
            image={require('../../images/kriegsschiff-ru.svg')}
          />
        </div>
        <div className='unit'>
          <img
            src={require('../../images/kriegsschiff.svg')}
            className='ui image'
          />
          = 2
        </div>

        <div className='subtitle'>Sous-marins</div>
        <div className='column left'>
          <div className='number'>0</div>
          <Icons count={0} image={require('../../images/uboot-ua.svg')} />
        </div>
        <div className='column right'>
          <div className='number'>51</div>
          <Icons count={10} image={require('../../images/uboot-ru.svg')} />
        </div>
        <div className='unit'>
          <img src={require('../../images/uboot.svg')} className='ui image' />=
          5
        </div>

        <div className='source'>
          Source:{' '}
          <a
            href='https://www.iiss.org/publications/the-military-balance'
            target='_top'
          >
            IISS
          </a>
        </div>
      </div>
    </div>
  )
}
